import { observer } from 'mobx-react-lite';
import { Navigate } from 'react-router';
import { useStore } from '../../hooks/useStore';
import { Loading } from '../../lib/components';
import { useCardOnboarding } from '../../queries/pxtraCard';

/**
 * Lands the manager on whatever needs them: the setup while the Swan check
 * runs, the wallet once it is done.
 */
export const CardAreaIndexRedirect = observer(() => {
  const { companyStore } = useStore();
  const companyId = companyStore.company?.id ?? '';

  const { data: onboarding, isLoading } = useCardOnboarding(companyId);

  if (isLoading) return <Loading />;

  return <Navigate replace to={onboarding?.phase === 'verified' ? 'wallet' : 'settings'} />;
});
